var render, staticRenderFns
import script from "./VisTableComponents.vue?vue&type=script&lang=js"
export * from "./VisTableComponents.vue?vue&type=script&lang=js"
import style0 from "./VisTableComponents.vue?vue&type=style&index=0&id=359c4282&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c4282",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('359c4282')) {
      api.createRecord('359c4282', component.options)
    } else {
      api.reload('359c4282', component.options)
    }
    
  }
}
component.options.__file = "src/components/base/VisTableComponents.vue"
export default component.exports